function WTPRTP() {
  return (
    <div>
      <div style={{ width: "100%", height: "100%" }}>
        <iframe
          src="/WTPRTP.htm" // your HTML file in public folder
          title="MP Garud "
          width="100%"
          height="900px"
          style={{ border: "none" }}
        />
      </div>
    </div>
  );
}

export default WTPRTP;